const TourPlan = {

    // FIELDS
    "sales_person": "مندوب المبيعات",
    "type": "النوع",
    "day": "اليوم",
    "date": "التاريخ",
    "customer": "العميل",
    "grade": "الدرجة",
    "city": "المدينة",
    "address": "العنوان",
    "action": "الإجراء",
    "status": "الحالة",
    "search": "بحث",

    // PAGE HEADER
    "tour_plan": "خطة الجولة",

    // ERROR
    "error_sales_person": "يرجى اختيار مندوب المبيعات",
    "error_type": "يرجى اختيار النوع",
    "error_day": "يرجى اختيار اليوم",
    "error_date": "يرجى اختيار التاريخ",
    "error_min_customer": "يرجى إضافة عميل واحد على الأقل",
    "error_customer_nf": "العميل غير موجود",

    // TABLE HEADER
    "table_sales_person": "مندوب المبيعات",
    "table_day": "اليوم",
    "table_date": "التاريخ",
}

export default TourPlan;